<style lang="scss" scoped>
.PreviewTabbar {
  position: relative;
  top: -95px;
  z-index: 2;
  .bar {
    top: 186px;
    left: 0;
    width: 100%;
    height: 80px;
    background: #fff;
    display: flex;
    z-index: 2;
    text-align: center;
    padding-top: 10px;
    .item {
      flex: 1;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
<template>
  <div class="PreviewTabbar">
    <div class="bar">
      <div
        v-for="(item, index) in barList"
        :key="index"
        class="item"
      >
        <img
          v-if="item.icon || item.defaultHighIcon"
          :src="
            setIndex == index + 1
              ? item.iconHighlight || item.defaultHighIcon
              : item.icon || item.defaultIcon
          "
          class=""
          alt=""
        >
        <i
          v-else
          class="el-icon-s-tools"
        />
        <div :style="{ 'color': setIndex == index + 1 ? primaryColor : '#333' }">
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewTabbar',
  props: {
    barList: {
      type: Array,
      default: () => {
        return []
      }
    },
    primaryColor: {
      type: String,
      default: '#fff'
    },
    setIndex: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      showImgPicker: false
    }
  },
  created () {},
  methods: {
    handleClickChangeImage () {
      this.showImgPicker = true
    },
    onClosePicker () {
      this.showImgPicker = false
    },
    onChangePicker (data) {
      console.log(`onChangePicker:`, data)
      this.showImgPicker = false
      if (data.length > 0) {
        this.value.img = data[0].image_url
      }
      this.$emit('input', this.value)
    }
  }
}
</script>
